import SfFeatureFlagsModule from './SfFeatureFlags/feature-flags.module';
import SfAngularSQLQueryModule from './SfAngularSQLQuery/angular-sql-query.module';

export default angular.module('sfMobile.services.libs', [
  SfFeatureFlagsModule,
  SfAngularSQLQueryModule,
]).name;
